import { render, staticRenderFns } from "./inquiryElixir.vue?vue&type=template&id=0075f43c&scoped=true&"
import script from "./inquiryElixir.vue?vue&type=script&lang=js&"
export * from "./inquiryElixir.vue?vue&type=script&lang=js&"
import style0 from "./inquiryElixir.vue?vue&type=style&index=0&id=0075f43c&lang=scss&scoped=true&"
import style1 from "./inquiryElixir.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./inquiryElixir.vue?vue&type=style&index=2&id=0075f43c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0075f43c",
  null
  
)

export default component.exports